<template>
  <div
    class="fixed bottom-0 flex flex-col w-full max-h-full transform -translate-x-1/2 shadow md:bottom-1/2 left-1/2 bg-primary rounded-t-xl md:rounded-xl md:translate-y-1/2 z-3 modal-translate modal"
    :class="{
      [widthClass]: true,
    }"
  >
    <h4 class="mx-4 mt-3 mb-1 text-tertiary">
      <slot name="subtitle">
        <span>Seppanen Construction</span>
        <!-- <span v-else> -->
        <!-- <span class="mr-2 text-white">{{ job.customer_name }}</span>
          <span v-if="job.address">{{ job.address.address }}</span> -->
        <!-- </span> -->
      </slot>
    </h4>
    <div
      class="flex flex-col flex-shrink w-full px-3 overflow-y-auto text-black bg-white border-2 rounded-t-xl md:rounded-xl md:px-6"
    >
      <h2 class="flex-none my-4">
        <slot name="title" />
      </h2>
      <div class="flex-auto overflow-auto md:px-4">
        <slot />
        <div
          class="flex flex-row items-end justify-between flex-none w-full my-8"
        >
          <slot name="actions" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'

const props = defineProps({
  widthClass: {
    type: String as PropType<string>,
    default: 'max-w-lg',
  },
})
</script>

<style scoped>
@media screen and (min-width: 768px) {
  .modal-translate {
    --tw-translate-y: 50%;
  }
}
</style>
